import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { MatchListStoreModel } from '../match-list/utils/match-list-models';
import ScoreElement from './score-element';
import { getFilteredMatchesWithEventsSelector } from '@om-fe/core/components/event-slider/event-slider.selectors';
import { EventSliderStoreMainModel } from '@om-fe/core/components/event-slider/event-slider.store';
import getSlice from '@om-fe/core/utils/get-slice';
import { BemMethod, createBem } from '@om-fe/utils';
import RedCardsInfoElement from './red-cards-info-element';
import getConfig from '@om-fe/core/utils/config';

export interface MatchInfoScorePublicProps {
    readonly sliceKey: string;
    readonly matchId: string;
    readonly isEventSlider?: boolean;
}

interface MatchInfoScoreStoreProps {
    readonly scoreElements?: string[];
    readonly homeParticipantId?: string;
    readonly sportId?: string;
    readonly redCardsId?: string;
}

export type MatchInfoScoreProps = MatchInfoScorePublicProps & MatchInfoScoreStoreProps;

const bem: BemMethod = createBem({
    name: 'Score',
});

const showRedCardsInfo: boolean = getConfig().matchListConfig?.liveSports?.showRedCardsInfo ?? false;

export class MatchInfoScoreComponent extends React.PureComponent<MatchInfoScoreProps> {

    render() {
        const { scoreElements, sportId, homeParticipantId, sliceKey, isEventSlider, redCardsId } = this.props;

        if (!scoreElements) {
            return null;
        }

        const moreThanOne: boolean = scoreElements.length > 1;

        return (
            <div
                className={bem({
                    modifiers: `${sportId}`,
                })}
            >
                {showRedCardsInfo &&
                    <RedCardsInfoElement
                        sliceKey={sliceKey}
                        redCardsId={redCardsId}
                        homeParticipantId={homeParticipantId}
                    />
                }
                {scoreElements.map((scoreElement: string) => (
                    <ScoreElement
                        key={scoreElement}
                        sliceKey={sliceKey}
                        scoreElementId={scoreElement}
                        homeParticipantId={homeParticipantId}
                        moreThanOne={moreThanOne}
                        isEventSlider={isEventSlider}
                    />
                ))}
            </div>
        );

    }
}

const MatchInfoScore: React.ComponentType<MatchInfoScorePublicProps> = connect<MatchInfoScoreStoreProps, undefined, MatchInfoScorePublicProps>(
    () => {
        const eventSliderFilteredMatchesWithEvents = getFilteredMatchesWithEventsSelector();

        return (state: AppState, props: MatchInfoScorePublicProps): MatchInfoScoreStoreProps => {
            const { matchId, sliceKey, isEventSlider } = props;
            const slice: MatchListStoreModel | EventSliderStoreMainModel | undefined = getSlice<MatchListStoreModel | EventSliderStoreMainModel>(state, sliceKey);

            if (!slice) {
                return {};
            }

            const { homeParticipantId, sportId, scoreElements, redCardsId } = isEventSlider ?
                eventSliderFilteredMatchesWithEvents(slice as EventSliderStoreMainModel)[matchId] :
                (slice as MatchListStoreModel).filteredMatchesWithEvents[matchId];

            return {
                scoreElements,
                homeParticipantId,
                sportId,
                redCardsId,
            };
        };
    },
)(MatchInfoScoreComponent);

export default MatchInfoScore;
